<cc-script-loader [scriptParams]="scriptParamsArray[0]"></cc-script-loader>
<cc-script-loader [scriptParams]="scriptParamsArray[1]"></cc-script-loader>

<div class="upselling-recommendation__intro">
  <h2 class="wb-type-heading-s">{{ 'upsellingRecommendation.headline' | translate }}</h2>
  <p class="wb-type-copy">
    {{ 'upsellingRecommendation.copy' | translate }}
  </p>
</div>

<!--
  ℹ️ with every vehicle change (e.g. when adding or removing a recommendation) we get a new vehicle id.
  on the other hand the vehicle id in the recommendation component must _not_ be changed
  (as long we are on the same page / the instance of this component exists) in order to work correctly.
  that's why the component itself just takes the first value and dismisses the updated vehicle ids
  => no magic on our side needed.
-->
<boe-upsell-recommendation
  *ngIf="vehicleId$ | async as vehicleId"
  [attr.current-vehicle-id]="vehicleId"
  [current-vehicle-id]="vehicleId"
  (vehicle)="onVehicleChange($event)"
></boe-upsell-recommendation>
